<template>
    <b-row>
        <b-col md="6">
            <b-card no-body>
                <b-card-header>
                    <b-card-title>Aprobados por intentos (3)</b-card-title>
                </b-card-header>

                <b-card-body>
                    <chartjs-component-bar-chart
                        :height="520"
                        :data="data"
                        :options="chartjsData.latestBarChart.options"
                    />
                </b-card-body>
            </b-card>
        </b-col>
        <b-col lg="6">
            <b-card no-body>
                <b-card-body>
                    <b-row>
                        <b-col md="12" v-if="$can('all', 'manage')">
                            <b-form-group
                                label="Seleccionar cliente"
                                label-for="customer"
                            >
                                <v-select
                                    id="customer"
                                    v-model="customer"
                                    label="name"
                                    placeholder="-- Seleccione un cliente --"
                                    :options="customers"
                                    trim
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-form-group
                                label="Seleccionar curso(s)"
                                label-for="course"
                            >
                                <v-select
                                    id="course"
                                    v-model="coursesArray"
                                    multiple
                                    label="name"
                                    placeholder="-- Seleccione uno o más cursos --"
                                    :options="courses"
                                    trim
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-form-group
                                label="Seleccionar modulo(s)"
                                label-for="module"
                            >
                                <v-select
                                    id="module"
                                    v-model="modulesArray"
                                    multiple
                                    label="name"
                                    placeholder="-- Seleccione uno o más módulos --"
                                    :options="modules"
                                    trim
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-form-group
                                label="Seleccionar exámenes"
                                label-for="exam"
                            >
                                <v-select
                                    id="exam"
                                    v-model="examsArray"
                                    multiple
                                    label="name"
                                    placeholder="-- Seleccione uno o más exámenes --"
                                    :options="exams"
                                    trim
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-button variant="primary" block @click="getData">
                                <feather-icon
                                    icon="FilterIcon"
                                    size="16"
                                />
                                FILTRAR
                            </b-button>
                        </b-col>
                    </b-row>
                    <hr>
                    <json-excel :data="firstTableExport()" name="aprobados_por_intentos.xls"></json-excel>
                    <table class="table">
                        <thead class="thead-dark">
                        <tr>
                            <th>ITEM</th>
                            <th>NÚMERO DE INTENTO</th>
                            <th>CANTIDAD</th>
                            <th>%</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in table" :key="index">
                            <td v-text="index+1"></td>
                            <td v-text="item.text"></td>
                            <td v-text="item.count"></td>
                            <td v-text="item.percentageText"></td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                            <td colspan="2" class="text-right font-weight-bold">TOTAL</td>
                            <td class="bg-yellow-table" v-text="tableTotal"></td>
                            <td class="bg-yellow-table">100%</td>
                        </tr>
                        </tfoot>
                    </table>
                </b-card-body>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>

    import { BCard, BCardHeader, BCardBody, BCardTitle, BRow, BCol, BLink, BFormGroup, BButton } from 'bootstrap-vue';
    import ChartjsComponentBarChart from './charts-components/ChartjsComponentBarChart.vue';
    import JsonExcel from "./download-excel";
    import chartjsData from './chartjsData';
    import vSelect from 'vue-select';
    import axios from 'axios';

    export default {
        components: {
            BCard,
            BRow,
            BCol,
            BLink,
            BCardHeader,
            BCardBody,
            BCardTitle,
            JsonExcel,
            BFormGroup,
            BButton,
            vSelect,
            ChartjsComponentBarChart
        },
        data() {
            return {
                coursesArray: [],
                courses: [],
                customer: null,
                customers: [],
                modulesArray: [],
                modules: [],
                examsArray: [],
                exams: [],

                chartjsData,
                table: [],
                tableTotal: 0,
                data: null
            }
        },
        watch: {
            customer (newValue){

                this.coursesArray = [];
                this.modulesArray = [];
                this.examsArray = [];
                this.courses = [];
                this.modules = [];
                this.exams = [];

                if (newValue){
                    this.getCourses();
                }
            },
            coursesArray (newValue) {

                this.modulesArray = [];
                this.examsArray = [];
                this.modules = [];
                this.exams = [];

                if (newValue){
                    this.getModules();
                }
            },
            modulesArray (newValue) {

                this.examsArray = [];
                this.exams = [];

                if (newValue){
                    this.getExams();
                }
            }
        },
        beforeMount (){
            this.getCustomers();
            this.getData();
        },
        mounted (){
            let role = JSON.parse(localStorage.getItem('userData')).role;
            if (role == 'client'){
                this.customer = {
                    id: JSON.parse(localStorage.getItem('userData')).customer
                };
            }
        },
        methods: {
            async getCustomers (){
                let response = await axios.get(`${process.env.VUE_APP_HOST}/api/dashboard/customers/select`);
                this.customers = response.data;
            },
            async getCourses (){
                let response = await axios.get(`${process.env.VUE_APP_HOST}/api/dashboard/courses/select-filtered?customer=${this.customer.id}`);
                this.courses = response.data;
            },
            async getModules (){

                let coursesIds = [];

                this.coursesArray.map(item => {
                    coursesIds.push(item.id);
                });

                let response = await axios.get(`${process.env.VUE_APP_HOST}/api/dashboard/modules/select-filtered?courses=${coursesIds}`);
                this.modules = response.data;
            },
            async getExams(){

                let modulesIds = [];

                this.modulesArray.map(item => {
                    modulesIds.push(item.id);
                });

                let response = await axios.get(`${process.env.VUE_APP_HOST}/api/dashboard/exams/select-filtered?modules=${modulesIds}`);
                this.exams = response.data;
            },
            async getData (){

                let examsIds = [];
                this.examsArray.map(item => {
                    examsIds.push(item.id);
                });

                let coursesIds = [];
                this.coursesArray.map(item => {
                    coursesIds.push(item.id);
                });

                let modulesIds = [];
                this.modulesArray.map(item => {
                    modulesIds.push(item.id);
                });

                let customerId = this.customer ? this.customer.id : '';

                let response = await axios.get(`${process.env.VUE_APP_WEB}/api/statistics/approved-by-attempt?customer=${customerId}&courses=${coursesIds}&modules=${modulesIds}&exams=${examsIds}`);
                this.table = response.data.data;

                let datasetsData = [];

                response.data.data.map(item => {
                    datasetsData.push(item.count);
                });

                this.data = {
                    labels: ['Intento 1', 'Intento 2', 'Intento 3'],
                    datasets: [
                        {
                            data: datasetsData,
                            backgroundColor: this.chartjsData.latestBarChart.data.datasets[0].backgroundColor,
                            borderColor: 'transparent'
                        }
                    ]
                };
                this.tableTotal = response.data.data[0].count + response.data.data[1].count + response.data.data[2].count;
            },
            firstTableExport (){

                let array = [];

                for (let a=0; a<this.table.length; a++)
                {
                    let objBody = {
                        'ITEM': a+1,
                        'NUMERO INTENTO': this.table[a]["text"],
                        'CANTIDAD': this.table[a]["count"],
                        '%': this.table[a]["percentageText"]
                    };

                    array.push(objBody);
                }

                let objFoot = {
                    'ITEM': '',
                    'NUMERO INTENTO': 'TOTAL',
                    'CANTIDAD': this.tableTotal,
                    '%': '100%'
                };

                array.push(objFoot);

                return array;
            }
        }
    }
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
</style>

<style scoped>

    table {
        text-align: center;
    }

    table th {
        text-transform: uppercase;
    }

    table th, table td {
        vertical-align: middle;
    }

    table tbody tr td:nth-child(2) {
        text-align: left;
    }

    .subtitle-filter {
        text-transform: uppercase;
        font-weight: bold;
        margin-bottom: 1rem;
    }

    .bg-yellow-table {
        background-color: rgba(255, 255, 0, 1);
        font-weight: bold;
    }

    .table-avg tbody tr td:nth-child(3) {
        text-align: left;
    }

</style>
